interface DecodedResponse<ResponseType> {
  response?: ResponseType; // parsed server error
  responseText?: string; // original server error
}

export function decodeJSONBuffer<ResponseType>(buffer?: Buffer): DecodedResponse<ResponseType> {
  if (!buffer) return {};
  const responseText = decode(buffer);
  const response = parse<ResponseType>(responseText || '');
  return { responseText, response };
}

function decode(buffer: Buffer) {
  try {
    const decoder = new TextDecoder('utf-8');
    return decoder.decode(buffer);
  } catch {
    return;
  }
}

function parse<ResponseType>(str: string) {
  try {
    return JSON.parse(str) as ResponseType;
  } catch {
    return;
  }
}
